import { render, staticRenderFns } from "./AddOrderCustomer.vue?vue&type=template&id=62282109&"
import script from "./AddOrderCustomer.vue?vue&type=script&lang=js&"
export * from "./AddOrderCustomer.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderCustomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports